import { ProjectOverviewFieldsProps } from 'components/ProjectOverview';

export const getCities = (items: ProjectOverviewFieldsProps[]) => {
  const cities = items.map((item) => item.fields.city.value);

  return [...new Set(cities)];
};
